import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import { Redirect, Switch, useRouteMatch } from 'react-router';
import { AppState } from '../../store/appState';
import {
    LOANFORMAT_EAUDIOBOOKS,
    LOANFORMAT_EBOOKS,
    URL_LOANFORMAT_ALL,
    URL_LOANFORMAT_EAUDIOBOOKS,
    URL_LOANFORMAT_EBOOKS
} from '../../store/loanFormat/actions';
import { PageNotFound } from '../../shop/PageNotFound';
import { CollectionByGenrePage } from './by-genre/CollectionByGenrePage';
import { CompleteCollectionPage } from './complete/CompleteCollectionPage';
import { CollectionNewlyAddedPage } from './newly-added/CollectionNewlyAddedPage';
import { CollectionSearchResultPage } from '../../shared/search/CollectionSearchResultPage';
import { CheckLoanFormat } from '../../shared/components/CheckLoanFormat';

const RouteSwitch: FC = () => {
    const { path, url } = useRouteMatch();
    const currentLoanFormat = useSelector(selectLoanFormatForURL);

    return (
        <Switch>
            <Route exact path={path}>
                <Redirect to={`${url}/complete`} />
            </Route>
            <Route exact path={`${path}/complete`}>
                <Redirect to={`${url}/complete/${currentLoanFormat}`} />
            </Route>

            <Route exact path={`${path}/complete/:loanFormat`}>
                <CheckLoanFormat>
                    <CompleteCollectionPage />
                </CheckLoanFormat>
            </Route>
            <Route exact path={`${path}/search/:loanFormat`}>
                <CheckLoanFormat>
                    <CollectionSearchResultPage />
                </CheckLoanFormat>
            </Route>
            <Route exact path={`${path}/newly-added`}>
                <Redirect to={`${url}/newly-added/${currentLoanFormat}`} />
            </Route>
            <Route path={`${path}/newly-added/:loanFormat`}>
                <CheckLoanFormat>
                    <CollectionNewlyAddedPage />
                </CheckLoanFormat>
            </Route>
            <Route exact path={`${path}/by-genre`}>
                <Redirect to={`${url}/by-genre/all`} />
            </Route>
            <Route path={`${path}/by-genre/:loanFormat/:genre?/:subgenre?`}>
                <CheckLoanFormat>
                    <CollectionByGenrePage />
                </CheckLoanFormat>
            </Route>
            <Route>
                <PageNotFound />
            </Route>
        </Switch>
    );
};

export default RouteSwitch;

function selectLoanFormatForURL(state: AppState): string {
    switch (state.loanFormat.key) {
        case LOANFORMAT_EBOOKS:
            return URL_LOANFORMAT_EBOOKS;
        case LOANFORMAT_EAUDIOBOOKS:
            return URL_LOANFORMAT_EAUDIOBOOKS;
        default:
            return URL_LOANFORMAT_ALL;
    }
}
